












import {Vue, Component, Prop} from 'vue-property-decorator'
import notAvailableImage from '@/assets/img/not-available.png'

@Component({})
export default class TokenImageRender extends Vue {
  @Prop({type: String, default: null}) imageUrl!: string

  get tokenImageUrl(): string {
    if (!this.imageUrl) {
      return notAvailableImage
    }

    return this.imageUrl
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement
    target.src = notAvailableImage
  }
}
